import React, { Component } from 'react';
import './styles.css';

/**
 * The template for the footer for the landing page.
 *
 * @typedef {Object} Props
 * @prop {Object} [content]
 *
 * @augments {Component<Props>}
 */
export default class Footer extends Component {

	/**
	 * @param {{ replace: (arg0: string, arg1: number) => any; }} content
	 */
	genContent = (content) => content
		.replace('{year}', new Date().getFullYear());

	render () {
		const { content } = this.props;

		return (
			<div className='HubFooter'>
				<p className='Footer-copy'>{this.genContent(content)}</p>
			</div>
		);
	}

}



// WEBPACK FOOTER //
// ./src/components/templates/HubFooter/HubFooter.js